import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { applyThemeMode } from "../lib/theme";
import type { ThemeMode } from "../lib/theme";

interface ThemeState {
  mode: ThemeMode;
}

// Стартираме светло; истинската стойност идва от личните настройки на
// потребителя (UserConfigurationSync) веднага щом токенът и заявката са налице.
const initialState: ThemeState = { mode: "light" };

applyThemeMode(initialState.mode);

// Заварени ключове от старите версии (темата до 0.0.234, свитите групи и
// изгледът на каталога в „Маркиране" до 14.09.2026 живееха в localStorage) —
// чистят се еднократно; могат да отпаднат след няколко релийза.
try {
  localStorage.removeItem("app_theme");
  localStorage.removeItem("ordering_category_rows_collapsed");
  localStorage.removeItem("ordering_catalog_view");
} catch {
  /* storage недостъпен */
}

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    // Само прилага в store-а и върху <html>. Записът в базата е отговорност на
    // извикващия (ThemeModal → useUpdateUserConfiguration).
    setThemeMode(state, action: PayloadAction<ThemeMode>) {
      state.mode = action.payload;
      applyThemeMode(action.payload);
    },
  },
});

export const { setThemeMode } = themeSlice.actions;
export default themeSlice.reducer;
